module.exports = __webpack_public_path__ + "img/amethyst-coral.fe558469.png";